import React from 'react';
import PropTypes from 'prop-types';

import { Card, TitleCard, SubTitleCard, HeaderCard, ContentCard } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import Style from './swapSeatList.module.css';
import SwapSeatItem from './swapSeatItem';

export default function SwapSeatList({ children = null, attendees = [], attendeesSelected = {}, onClick = () => {} }) {
    const { t } = useTranslation();

    return (
        <Card className={Style['swap-seat-list']}>
            <div className={Style['content-container']}>
                <HeaderCard separator={false}>
                    <TitleCard className={Style['title']} title={t('ticket.swapSeat.list.title')} />
                    <SubTitleCard title={t('ticket.swapSeat.list.subtitle')} />
                </HeaderCard>
                <ContentCard className={Style['content']}>
                    {attendees.map((attendee, index) => (
                        <SwapSeatItem key={attendee.attendee.pk} attendee={attendee} onClick={onClick} selected={attendee.attendee.pk in attendeesSelected} />
                    ))}
                </ContentCard>
            </div>
            <ContentCard className={Style['footer']}>{children}</ContentCard>
        </Card>
    );
}

SwapSeatList.propTypes = {
    children: PropTypes.node,
    attendees: PropTypes.array,
    attendeesSelected: PropTypes.object,
    onClick: PropTypes.func
};
